import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { ReportCard } from 'src/design/molecules/ReportCard';

const REPORTS = [
  {
    title: 'Job Financials Report',
    description:
      'Access financial analytics for jobs across your organization.',
    link: import.meta.env.VITE_REPORT_URL_JOB_FINANCIALS,
  },
];

export const Analytics: React.FC = () => {
  return (
    <>
      <Header
        title="Data Analytics"
        helpText="Access analytical reports for your organization."
        breadcrumbProps={{
          items: [{ text: 'Analytics' }],
        }}
      />

      <SimpleGrid cols={{ base: 1, md: 3, lg: 4 }}>
        {REPORTS.map((report) => (
          <ReportCard
            key={report.title}
            title={report.title}
            description={report.description}
            link={report.link}
            target="_blank"
          />
        ))}
      </SimpleGrid>
    </>
  );
};
